var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "main-content", staticStyle: { overflow: "auto" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isPreview,
                  expression: "!isPreview"
                }
              ],
              class: _vm.readonly ? "not-click" : "",
              staticStyle: { width: "fit-content" }
            },
            [
              _vm.addedElements && _vm.addedElements.length > 0
                ? _c("div", { staticClass: "section" }, [
                    _c(
                      "span",
                      { staticClass: "title", staticStyle: { width: "100%" } },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.SystemAddedItem"))
                          )
                        ]),
                        _vm._v(
                          "（" +
                            _vm._s(
                              _vm.$t("SystemMaintenance.DragTheBlockUse")
                            ) +
                            "） "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      _vm._l(_vm.addedElements, function(element) {
                        return _c(
                          "div",
                          {
                            key: element.pagePartElement.elementName,
                            ref: "added" + element.pagePartElement.elementName,
                            refInFor: true,
                            staticStyle: {
                              width: "fit-content",
                              display: "inline-block",
                              "line-height": "30px",
                              margin: "0 15px"
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "vertical-align": "middle" } },
                              [_vm._v(_vm._s(element.sysLabel))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-content sort-char",
                                staticStyle: { "line-height": "unset" },
                                on: {
                                  mousedown: function($event) {
                                    return _vm.onAddedMousedown($event, element)
                                  }
                                }
                              },
                              [_vm._v("≡")]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                _vm._l(_vm.upBlocks, function(block) {
                  return _c(
                    "div",
                    {
                      key: block.pagePart.pagePartName,
                      ref: block.pagePart.pagePartName,
                      refInFor: true,
                      staticClass: "section",
                      staticStyle: { width: "426px", "margin-right": "5px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            disabled: _vm.readonly,
                            "label-width": "125px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "title",
                              staticStyle: { width: "100%" }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(block.customLabel || block.sysLabel) +
                                  " "
                              ),
                              _c("i", {
                                staticClass: "el-icon-edit",
                                staticStyle: { "margin-left": "5px" },
                                on: {
                                  click: function($event) {
                                    return _vm.onEditBlockLabel(block)
                                  }
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "sort-char",
                                  staticStyle: { float: "right" },
                                  on: {
                                    mousedown: function($event) {
                                      return _vm.onMousedown($event, block)
                                    }
                                  }
                                },
                                [_vm._v("≡")]
                              )
                            ]
                          ),
                          _c("el-form-item", { attrs: { label: " " } }, [
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("SeaExport.Display") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Display")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.MainTicket")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemMaintenance.MainTicket"))
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.SlaveTicket")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SystemMaintenance.SlaveTicket")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("SeaExport.Required") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Required")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                staticStyle: { width: "80px" },
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.Alias")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemMaintenance.Alias"))
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("Tool.Setting") }
                              },
                              [_vm._v(_vm._s(_vm.$t("Tool.Setting")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.Sort")
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Sort")))]
                            )
                          ]),
                          _vm._l(block.uiCustomElementList, function(element) {
                            return _c(
                              "el-form-item",
                              {
                                key: element.pagePartElement.elementName,
                                ref: element.pagePartElement.elementName,
                                refInFor: true
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: element.isRequire ? "blue" : "",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [_vm._v(_vm._s(element.sysLabel))]
                                ),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: {
                                    disabled:
                                      !element.pagePartElement
                                        .displayCanCustom ||
                                      (!!element.hqUICustomElement &&
                                        element.hqUICustomElement.isRequire) ||
                                      _vm.checkHqSetDisable(element)
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.onDisplayChange(block, element)
                                    }
                                  },
                                  model: {
                                    value: element.isDisplay,
                                    callback: function($$v) {
                                      _vm.$set(element, "isDisplay", $$v)
                                    },
                                    expression: "element.isDisplay"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: {
                                    disabled:
                                      !element.pagePartElement
                                        .displayCanCustom ||
                                      !element.pagePartElement.masterIncluded ||
                                      !element.isDisplay ||
                                      (!!element.hqUICustomElement &&
                                        element.hqUICustomElement.isRequire) ||
                                      _vm.checkHqSetDisable(element)
                                  },
                                  model: {
                                    value: element.masterIsDisplay,
                                    callback: function($$v) {
                                      _vm.$set(element, "masterIsDisplay", $$v)
                                    },
                                    expression: "element.masterIsDisplay"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: {
                                    disabled:
                                      !element.pagePartElement
                                        .displayCanCustom ||
                                      !element.isDisplay ||
                                      (!!element.hqUICustomElement &&
                                        element.hqUICustomElement.isRequire) ||
                                      _vm.checkHqSetDisable(element)
                                  },
                                  model: {
                                    value: element.slaveIdDisplay,
                                    callback: function($$v) {
                                      _vm.$set(element, "slaveIdDisplay", $$v)
                                    },
                                    expression: "element.slaveIdDisplay"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: {
                                    disabled:
                                      !element.pagePartElement
                                        .requireCanCustom ||
                                      !element.isDisplay ||
                                      (!!element.hqUICustomElement &&
                                        element.hqUICustomElement.isRequire) ||
                                      _vm.checkHqSetDisable(element)
                                  },
                                  model: {
                                    value: element.isRequire,
                                    callback: function($$v) {
                                      _vm.$set(element, "isRequire", $$v)
                                    },
                                    expression: "element.isRequire"
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "element-column-text",
                                    staticStyle: {
                                      width: "80px",
                                      "pointer-events": "auto"
                                    },
                                    attrs: { title: element.customLabel }
                                  },
                                  [_vm._v(_vm._s(element.customLabel))]
                                ),
                                _c(
                                  "span",
                                  {
                                    class:
                                      "element-column-content" +
                                      (element.pagePartElement.aliasCanCustom &&
                                      _vm.branchId === 1 &&
                                      element.isDisplay
                                        ? ""
                                        : " el-icon-edit-disabled")
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-edit",
                                      on: {
                                        click: function($event) {
                                          return _vm.onEditElementLabel(element)
                                        }
                                      }
                                    })
                                  ]
                                ),
                                element.pagePartElement.elementName !== "jobNo"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "element-column-content sort-char",
                                        staticStyle: { "line-height": "unset" },
                                        on: {
                                          mousedown: function($event) {
                                            return _vm.onMousedown(
                                              $event,
                                              block,
                                              element
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("≡")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ]
          ),
          [
            _vm.addedElements && _vm.addedElements.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "section",
                    staticStyle: {
                      height: "0",
                      overflow: "hidden",
                      padding: "0",
                      "margin-bottom": "0"
                    }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "title", staticStyle: { width: "100%" } },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.SystemAddedItem"))
                          )
                        ]),
                        _vm._v(
                          "（" +
                            _vm._s(
                              _vm.$t("SystemMaintenance.DragTheBlockUse")
                            ) +
                            "） "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      _vm._l(_vm.addedElements, function(element) {
                        return _c(
                          "div",
                          {
                            key: element.pagePartElement.elementName,
                            ref:
                              "addDrag" + element.pagePartElement.elementName,
                            refInFor: true,
                            staticStyle: {
                              width: "fit-content",
                              display: "inline-block",
                              "line-height": "30px",
                              margin: "0 15px"
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "vertical-align": "middle" } },
                              [_vm._v(_vm._s(element.sysLabel))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-content sort-char",
                                staticStyle: { "line-height": "unset" }
                              },
                              [_vm._v("≡")]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              : _vm._e(),
            _vm._l(_vm.blocks, function(block) {
              return _c(
                "div",
                {
                  key: block.pagePart.pagePartName,
                  ref: "drag" + block.pagePart.pagePartName,
                  refInFor: true,
                  staticClass: "section",
                  staticStyle: {
                    width: "426px",
                    height: "0",
                    overflow: "hidden",
                    padding: "0",
                    "margin-bottom": "0"
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "125px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          staticStyle: { width: "100%" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(block.customLabel || block.sysLabel) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "el-icon-edit",
                            staticStyle: { "margin-left": "5px" }
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "sort-char",
                              staticStyle: { float: "right" }
                            },
                            [_vm._v("≡")]
                          )
                        ]
                      ),
                      _c("el-form-item", { attrs: { label: " " } }, [
                        _c(
                          "span",
                          {
                            staticClass: "element-column-text",
                            attrs: { title: _vm.$t("SeaExport.Display") }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Display")))]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "element-column-text",
                            attrs: {
                              title: _vm.$t("SystemMaintenance.MainTicket")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SystemMaintenance.MainTicket"))
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "element-column-text",
                            attrs: {
                              title: _vm.$t("SystemMaintenance.SlaveTicket")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SystemMaintenance.SlaveTicket"))
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "element-column-text",
                            attrs: { title: _vm.$t("SeaExport.Required") }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Required")))]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "element-column-text",
                            staticStyle: { width: "80px" },
                            attrs: { title: _vm.$t("SystemMaintenance.Alias") }
                          },
                          [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Alias")))]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "element-column-text",
                            attrs: { title: _vm.$t("Tool.Setting") }
                          },
                          [_vm._v(_vm._s(_vm.$t("Tool.Setting")))]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "element-column-text",
                            attrs: { title: _vm.$t("SystemMaintenance.Sort") }
                          },
                          [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Sort")))]
                        )
                      ]),
                      _vm._l(block.uiCustomElementList, function(element) {
                        return _c(
                          "el-form-item",
                          {
                            key: element.pagePartElement.elementName,
                            ref: "drag" + element.pagePartElement.elementName,
                            refInFor: true,
                            staticStyle: { "background-color": "#f0f3f8" }
                          },
                          [
                            _c(
                              "span",
                              {
                                class: element.isRequire ? "blue" : "",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(element.sysLabel))]
                            ),
                            _c("el-checkbox", {
                              staticClass: "element-column-content",
                              model: {
                                value: element.isDisplay,
                                callback: function($$v) {
                                  _vm.$set(element, "isDisplay", $$v)
                                },
                                expression: "element.isDisplay"
                              }
                            }),
                            _c("el-checkbox", {
                              staticClass: "element-column-content",
                              model: {
                                value: element.masterIsDisplay,
                                callback: function($$v) {
                                  _vm.$set(element, "masterIsDisplay", $$v)
                                },
                                expression: "element.masterIsDisplay"
                              }
                            }),
                            _c("el-checkbox", {
                              staticClass: "element-column-content",
                              model: {
                                value: element.slaveIdDisplay,
                                callback: function($$v) {
                                  _vm.$set(element, "slaveIdDisplay", $$v)
                                },
                                expression: "element.slaveIdDisplay"
                              }
                            }),
                            _c("el-checkbox", {
                              staticClass: "element-column-content",
                              model: {
                                value: element.isRequire,
                                callback: function($$v) {
                                  _vm.$set(element, "isRequire", $$v)
                                },
                                expression: "element.isRequire"
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                staticStyle: { width: "80px" },
                                attrs: { title: element.customLabel }
                              },
                              [_vm._v(_vm._s(element.customLabel))]
                            ),
                            _c(
                              "span",
                              { staticClass: "element-column-content" },
                              [_c("i", { staticClass: "el-icon-edit" })]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-content sort-char",
                                staticStyle: { "line-height": "unset" }
                              },
                              [_vm._v("≡")]
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            })
          ],
          _vm.isPreview
            ? _c("basic-tab-UICustom", {
                attrs: {
                  context: _vm.bookingWorkspaceContext,
                  action: "look",
                  "preview-config": _vm.previewConfig
                }
              })
            : _vm._e()
        ],
        2
      ),
      _c("block-set-dialog", {
        attrs: {
          visible: _vm.blockSetDialog.visible,
          block: _vm.blockSetDialog.block
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.blockSetDialog, "visible", $event)
          }
        }
      }),
      _c("element-set-dialog", {
        attrs: {
          visible: _vm.elementSetDialog.visible,
          element: _vm.elementSetDialog.element
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.elementSetDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }